import toast, { Toaster } from "react-hot-toast";
import { FaCheck } from "react-icons/fa";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { useEffect, useState } from "react";
import { ApplyDiscountCode } from "../../api/api";
import { CheckOutApi } from "../../api/get";
import { useNavigate, useLocation } from "react-router-dom";
import Spinner from "../../Common/Spinner";
import Header from "../../Common/Header";
import { handleApiError } from "../../Common/Helper";

const PurchaseComp = () => {
  const [discountCode, setDiscountCode] = useState(null);
  const [discountDetails, setDiscountDetails] = useState();
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { updatedPackage } = location.state || {};
  console.log("updatedPackage =>",updatedPackage)
  // Redirect to dashboard if location.state is null
  useEffect(() => {
    if (!updatedPackage) {
      navigate(-1);
    }
  }, [updatedPackage, navigate]);

  console.log("discountCode =>", discountCode);
  console.log("discountDetails =>", discountDetails);
  const getNextYearToday = () => {
    const today = new Date();
    const nextYear = today.getFullYear() + 1;
    // Get the day and month
    const day = today.getDate().toString().padStart(2, "0");
    const month = today.toLocaleString("default", { month: "long" });
    // Format the date as "DD Month YYYY"
    return `${day} ${month} ${nextYear}`;
  };
  const handleClickDiscountCode = () => {
    setLoader(true);
    const data = {
      discount_code: discountCode,
      price: updatedPackage?.price,
    };
    if (discountCode) {
      ApplyDiscountCode(data)
        .then((res) => {
          if (res.success == true && res.status_code === "200") {
            setLoader(false);
            if (res.data.discount_applied === true) {
              setDiscountDetails(res.data);
              toast.success("Discount Code Applied");
            } else {
              toast.success("Discount Code Not Applied");
            }
          } else {
            handleApiError(res,navigate);
            setLoader(false);
          }
          console.log("res =>", res.data);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      toast.error("Please enter a discount code.");
      setLoader(false);
      return;
    }
  };
  function convertArrayToURL(data, discountCode) {
    return `package_id=${data.id}&discount_code=${
      discountDetails?.discount_applied ? discountCode : ""
    }&partner_email=${data.partnerEmail || ""}&subscription_status=${
      data?.BuySubscription
    }`;
  }
  const handleCheckout = () => {
    setLoading(false);
    const data = convertArrayToURL(updatedPackage, discountCode);
    console.log("url =>", data);
    CheckOutApi(data)
      .then((res) => {
        setLoader(true);
        if (res.success  && res.status_code === "200") {
          setTimeout(() => {
            window.location.href = res.data.url; // Redirect in the same tab
          }, 1000);
        } else {
          handleApiError(res,navigate);
          toast.error("Payment is invalid");
        }
        setLoading(false);
        setLoader(false);
      })
      .catch((err) => {
        setLoading(false);
        setLoader(false);
        console.log(err);
      });
  };

  return (
    <>
      <Toaster />
      <Header />
      <div className="bg-primary w-full h-screen">
        <div className="container">
          <div className="grid grid-cols-2 max-md:grid-cols-1 text-black ">
            <div className="bg-[#fff] h-auto p-5">
                <p className="font-bold text-[22px] md:text-[26px] sm:text-[22px] lg:text-[28px]">Your purchase</p>
                <div className="flex justify-between items-center py-5 border-b-2 border-dashed">
                  <p className="font-bold">Total price for a single will</p>
                  <p className="font-bold">
                    A$ {parseInt(updatedPackage?.price)}
                  </p>
                </div>
                <div className="mt-5 flex items-center gap-3  pb-2">
                  <input
                    type="text"
                    placeholder="discount code"
                    className="w-full rounded-sm px-5 py-2 border-[1px]"
                    onChange={(e) => setDiscountCode(e.target.value)}
                  />
                  {loader ? (
                    <button className="bg-primary text-white px-4 py-2">
                      Applied...
                    </button>
                  ) : (
                    <button
                      onClick={() => handleClickDiscountCode()}
                      disabled={!discountCode}
                      className={`bg-primary text-white px-4 py-2 rounded-[5px] font-bold ${
                        !discountCode ? "opacity-50" : ""
                      }`}
                    >
                      Apply
                    </button>
                  )}
                </div>
                {discountDetails?.discount_applied === true && (
                  <p className="text-slate-500 text-[16px] font-bold pt-3">
                    Congrats ! You got {discountDetails?.discount_percentage}{" "}
                    % discount
                  </p>
                )}

                {updatedPackage?.BuySubscription === 1 && (
                  <div>
                    {/* <div className="border-b-2 border-dashed py-2">
                    </div> */}
                    <div className="flex justify-between items-center pt-5">
                      <p className="font-bold">Unlimited changes</p>
                      <p className="font-bold">
                        A$ {parseInt(updatedPackage?.subscription_price)} per
                        year
                      </p>
                    </div>
                    <div className="pt-3">
                      <p className="text-slate-500 text-[14px] sm:text-[16px] md:text-[16px] xl:text-[16px]">
                        Any changes are free for the first year. Your first
                        payment of A${" "}
                        {parseInt(updatedPackage?.subscription_price)} will be
                        on {getNextYearToday()}.
                      </p>
                    </div>
                  </div>
                )}
              <div className="mt-4">
                <button
                  onClick={() => handleCheckout()}
                  className="text-[14px] sm:text-[14px] md:text-[16px] xl:text-[16px] border-2 w-full rounded-[5px] bg-primary text-white border-[#240642] text-[#240642] px-4 py-3 font-bold"
                >
                  {!loading
                    ? "Redirect to Payment ...."
                    : `Confirm Payment of A$ ${
                        discountDetails?.final_amount ||
                        parseInt(updatedPackage?.price)
                      }`}
                </button>
              </div>
            </div>
            <div className="max-lg:hidden">
              <div className="fixed bottom-[0px] w-[500px] right-[6%]  flex justify-center">
                <img
                  src="/assets/images/1.png"
                  alt="wills-guru-logo-white"
                  className="h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseComp;
